export enum ICON_TYPE {
  INSTAGRAM = "instagram",
  LINKEDIN = "linkedin",
  PREV = "prev",
  CLOSE = "close",
}

export interface BaseIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  fill?: string;
  stroke?: string;
  className?: string;
}

export interface IconPropsModel extends BaseIconProps {
  type: ICON_TYPE;
}
